(function() {
    'use strict';

    // State
    var selectedColors = [];
    var packSize = 2;
    var PER_ITEM_DISCOUNT = 40;
    var purchasing = false;

    // DOM refs
    var mainImage = document.getElementById('mainImage');
    var thumbs = document.querySelectorAll('.product-thumbs img');
    var swatches = document.querySelectorAll('.swatch');
    var selectedContainer = document.getElementById('selectedColors');
    var colorCount = document.getElementById('colorCount');
    var addToCartBtn = document.getElementById('addToCart');
    var packSelector = document.getElementById('packSelector');

    if (!addToCartBtn) return;

    // Try to read variant data from Liquid-injected JSON
    var variantData = null;
    var variantDataEl = document.getElementById('product-variant-data');
    if (variantDataEl) {
        try {
            variantData = JSON.parse(variantDataEl.textContent);
        } catch(e) {}
    }

    var unitPrice = variantData ? variantData.price / 100 : 490;
    var root = (variantData && variantData.root || '/').replace(/\/?$/, '/');

    // --- Effective pieces: pack size, or number of colours if more selected ---
    function effectivePieces() {
        var c = selectedColors.length;
        if (c >= 2) return c;
        return packSize;
    }

    function totalPrice(pieces) {
        var total = pieces * unitPrice;
        if (pieces >= 2) total -= PER_ITEM_DISCOUNT * pieces;
        return total;
    }

    // --- Thumbnail gallery ---
    thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
            thumbs.forEach(function(t) { t.classList.remove('active'); });
            thumb.classList.add('active');
            mainImage.style.opacity = '0';
            setTimeout(function() {
                mainImage.src = thumb.dataset.full || thumb.src;
                mainImage.style.opacity = '1';
            }, 200);
        });
    });

    // --- Pack selector ---
    function setPack(n, fromUser) {
        packSize = Math.max(2, n);
        if (packSelector) {
            packSelector.querySelectorAll('.pack-option').forEach(function(opt) {
                var on = parseInt(opt.dataset.pack) === n;
                opt.classList.toggle('selected', on);
                opt.setAttribute('aria-checked', on ? 'true' : 'false');
            });
        }
        // Picking "1 piece" with several colours selected: keep only the latest colour
        if (fromUser && n === 1 && selectedColors.length > 1) {
            var keep = selectedColors[selectedColors.length - 1];
            selectedColors.forEach(function(c) {
                if (c.name !== keep.name) {
                    var sw = document.querySelector('.swatch[data-name="' + c.name + '"]');
                    if (sw) sw.classList.remove('selected');
                }
            });
            selectedColors = [keep];
            updateSelectedUI();
        }
        updateCartPrice();
    }

    if (packSelector) {
        packSelector.querySelectorAll('.pack-option').forEach(function(opt) {
            opt.addEventListener('click', function() { setPack(parseInt(opt.dataset.pack), true); });
            opt.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPack(parseInt(opt.dataset.pack), true); }
            });
        });
    }

    // --- Color swatch multi-selection ---
    function updateSelectedUI() {
        var c = selectedColors.length;
        swatches.forEach(function(swatch) {
            swatch.setAttribute('aria-pressed', String(selectedColors.some(function(col) { return col.name === swatch.dataset.name; })));
        });
        var hint = '';
        if (c === 0) hint = '0 selected';
        else if (c === 1 && packSize === 2) hint = '1 selected — you’ll get 2 of this colour (or pick another)';
        else hint = c + ' selected';
        colorCount.textContent = hint;
        selectedContainer.innerHTML = selectedColors.map(function(col) {
            return '<span class="selected-tag">' +
                '<span style="width:12px;height:12px;border-radius:50%;background:' + col.hex + '; display:inline-block"></span> ' +
                col.name +
                ' <button type="button" class="remove" aria-label="Remove ' + col.name + '" data-name="' + col.name + '">×</button>' +
                '</span>';
        }).join('');

        selectedContainer.querySelectorAll('.remove').forEach(function(btn) {
            btn.addEventListener('click', function() {
                var name = btn.dataset.name;
                selectedColors = selectedColors.filter(function(c) { return c.name !== name; });
                var sw = document.querySelector('.swatch[data-name="' + name + '"]');
                if (sw) sw.classList.remove('selected');
                updateSelectedUI();
                updateCartPrice();
            });
        });
    }

    swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
            var name = swatch.dataset.name;
            if (swatch.dataset.soldout) {
                colorCount.textContent = name + ' is out of stock';
                return;
            }
            var hex = swatch.dataset.hex || swatch.style.background || swatch.style.backgroundColor;
            var variantId = swatch.dataset.variantId;
            var imageUrl = swatch.dataset.image;

            if (swatch.classList.contains('selected')) {
                swatch.classList.remove('selected');
                selectedColors = selectedColors.filter(function(c) { return c.name !== name; });
            } else {
                swatch.classList.add('selected');
                selectedColors.push({ name: name, hex: hex, variantId: variantId, image: imageUrl });

                // Selecting a 2nd+ colour implies the 2-pack
                if (selectedColors.length >= 2 && packSize === 1) setPack(2, false);

                // Switch main image
                if (imageUrl) {
                    mainImage.style.opacity = '0';
                    setTimeout(function() {
                        mainImage.src = imageUrl;
                        mainImage.style.opacity = '1';
                    }, 200);
                }

                // Activate matching thumbnail
                thumbs.forEach(function(t) {
                    t.classList.remove('active');
                    if (t.alt && t.alt.toLowerCase().indexOf(name.toLowerCase()) === 0) {
                        t.classList.add('active');
                        if (!imageUrl) {
                            mainImage.style.opacity = '0';
                            setTimeout(function() {
                                mainImage.src = t.dataset.full || t.src;
                                mainImage.style.opacity = '1';
                            }, 200);
                        }
                    }
                });
            }
            updateSelectedUI();
            updateCartPrice();
        });
    });

    // --- Price + button text ---
    function updateCartPrice() {
        var pieces = effectivePieces();
        var total = totalPrice(pieces);
        var label = pieces === 1 ? 'Add to Cart' : 'Add ' + pieces + ' to Cart';
        addToCartBtn.textContent = label + ' — ₹' + total.toLocaleString('en-IN');
        if (packSelector) {
            packSelector.querySelector('.pack-name').textContent = pieces + ' pieces';
            packSelector.querySelector('.pack-price').textContent = '₹' + total.toLocaleString('en-IN');
        }

        var shippingNote = document.querySelector('.shipping-note');
        var shippingNoteText = document.querySelector('.shipping-note span:last-child');
        if (shippingNote && shippingNoteText) {
            if (pieces >= 2) {
                shippingNoteText.innerHTML = '<strong>₹450 each · delivered free</strong> when you pay online.';
                shippingNote.hidden = false;
                shippingNote.style.display = '';
            } else {
                shippingNote.hidden = true;
                shippingNote.style.display = 'none';
            }
        }
    }

    // --- Build cart items from selection ---
    function buildItems() {
        var pieces = effectivePieces();
        var items = [];
        if (selectedColors.length === 0) return items; // caller nudges colour pick
        if (selectedColors.length === 1) {
            items.push({ id: parseInt(selectedColors[0].variantId), quantity: pieces });
        } else {
            selectedColors.forEach(function(color) {
                if (color.variantId) items.push({ id: parseInt(color.variantId), quantity: 1 });
            });
        }
        return items;
    }

    function nudgeColourPick() {
        var section = document.querySelector('.color-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
            section.classList.remove('shake');
            void section.offsetWidth; // restart animation
            section.classList.add('shake');
        }
        colorCount.textContent = 'pick a colour first';
    }

    // --- Add to Cart (Shopify AJAX Cart API) → opens drawer ---
    addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (purchasing) return;

        if (!variantData) {
            // Variant data failed to render — never fake success
            addToCartBtn.textContent = 'Couldn\'t load product — refresh the page';
            setTimeout(function() { updateCartPrice(); }, 3000);
            return;
        }

        var items = buildItems();
        if (items.length === 0) { nudgeColourPick(); return; }

        addToCartBtn.disabled = true;
        purchasing = true;
        addToCartBtn.textContent = 'Adding...';

        fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function(res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function() {
            addToCartBtn.textContent = 'Added ✓';
            refreshCartCount();
            if (window.CottonCart) { window.CottonCart.openAfterAdd(); }
            setTimeout(function() {
                addToCartBtn.disabled = false; purchasing = false;
                updateCartPrice();
            }, 1200);
        })
        .catch(function() {
            purchasing = false; addToCartBtn.disabled = false;
            window.location.href = root + 'cart';
        });
    });

    // --- Buy it Now → add then straight to checkout ---
    var buyNowBtn = document.getElementById('buyNow');
    if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (purchasing) return;
            if (!variantData) { buyNowBtn.textContent = 'Couldn’t load colours — refresh the page'; return; }

            var items = buildItems();
            if (items.length === 0) { nudgeColourPick(); return; }

            buyNowBtn.disabled = true;
            purchasing = true;
            buyNowBtn.textContent = 'Taking you to checkout...';

            fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
            .then(function(res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
            .then(function() {
                if (window.CottonSalwarCartRules) return window.CottonSalwarCartRules.checkout(function() { window.location.href = root + 'cart'; });
                window.location.href = root + 'cart';
            })
            .catch(function() {
                window.location.href = root + 'cart';
            });
        });
    }

    // --- Refresh cart count badge ---
    function refreshCartCount() {
        fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
            var countEl = document.getElementById('cartCount');
            if (countEl) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
            }
        })
        .catch(function() {});
    }

    // --- Combo quick-select (legacy bundle section, harmless if absent) ---
    document.querySelectorAll('.combo').forEach(function(combo) {
        combo.addEventListener('click', function() {
            var colors = combo.dataset.colors.split(',');
            colors.forEach(function(colorName) {
                var swatch = document.querySelector('.swatch[data-name="' + colorName.trim() + '"]');
                if (swatch && !swatch.classList.contains('selected')) {
                    swatch.click();
                }
            });
            document.getElementById('product').scrollIntoView({ behavior: 'smooth' });
        });
    });

    // Initial state
    updateCartPrice();
})();
